import { postApi } from "../redux/api";

export async function sendSms({ recipient, message, sender_id }) {
  try {
    const res = await postApi("send_sms", {
      recipient,
      message,
      sender_id: sender_id || 'CPLNG',
    });

    if (res.success) {
      return { success: true, data: res.data };
    }

    console.error('[smsService] API error:', res);
    return { success: false, error: res.msg || 'Failed to send SMS' };
  } catch (err) {
    console.error('[smsService] Network error:', err);
    return { success: false, error: err.message };
  }
}

export function canSendSms() {
  return true;
}
